<template>
  <div>
    <div class="solution">
      <div class="solution_info">
        <div class="Product_mat">
          <div class="Product_mat_info">
            <div class="Product_mat_info_cn">解决方案</div>
            <div class="Product_mat_info_en">Product Solution</div>
          </div>
        </div>
        <div>
          <img src="../../assets/img/solution/home.webp" width="100%" alt="" />
        </div>
        <engine-model></engine-model>
      </div>

      <div class="solution_top_btn">
        <div class="solution_btn_box">
          <div class="Solution_m2menu">
            <button
              @click="tabChange"
              class="Solution_JCYY_btn"
              :class="{ Solution_JCYY_active: tab == 1 }"
              data-id="1"
            >
              设计模型轻量化
            </button>
            <button
              @click="tabChange"
              class="Solution_JCYY_btn"
              :class="{ Solution_JCYY_active: tab == 2 }"
              data-id="2"
            >
              SaaS化模型分享
            </button>
          </div>
        </div>
      </div>

      <div v-show="tab == 1">
        <div class="Solution_main_solve">
          <div class="Solution_solve_left">
            <div class="solve_left__text">
              <div class="solve_line">
                设计模型轻量化解决方案
              </div>
            </div>
            <div class="solve_left__content">
              <div>
                CAD模型轻量化解决方案，应用在研发设计阶段，支持多款CAD模型数据轻量化，不破坏原始模型信息，可在多种终端设备方式查看CAD模型数据。
              </div>
            </div>
          </div>
          <div class="Solution_solve_right">
            <div>
              <img
                src="../../assets/img/solution/qinglianghua.png"
                class="Solution_img"
              />
            </div>
          </div>
        </div>
        <div class="solution_pain">
          <div class="solution_pain_box">
            <div class="pain_title">行业痛点</div>
            <div class="pain_content">
              <div
                class="pain_box"
                v-for="(item, index) of painList"
                :key="index"
              >
                <div class="title">{{ item.title }}</div>
                <div class="container">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="solution_highlights">
          <div class="highlights">
            <div class="highlights_title">方案亮点</div>
            <div class="highlights_box">
              <div
                class="highlights_content"
                v-for="(item, index) in highlightList"
                :key="index"
              >
                <div class="contents">
                  <div class="left-circle"></div>
                  <div class="right-box">
                    <div
                      class="right"
                      v-for="(text, value) in item.content"
                      :key="value"
                    >
                      {{ text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="solution_plan">
          <div class="plan">
            <div class="plan_title">方案示例</div>
            <div class="plan_box">
              <div class="container">
                <div
                  class="plan-card"
                  v-for="(item, index) in planList"
                  :key="index"
                  ref="planCard"
                >
                  <img class="card-image" :src="item.url" />
                  <div class="card-content">
                    <div class="card-text">{{ item.text }}</div>
                    <div
                      class="card-button"
                      @click="viewExamples(item.examples)"
                    >
                      <div>查看示例</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="tab == 2" :class="{ active_upload_main: tab1 == isActive }">
        <div class="Solution_main_solve">
          <div class="Solution_solve_left">
            <div class="solve_left__text">
              <div class="solve_line">
                SaaS化模型分享解决方案
              </div>
            </div>
            <div class="saas_left__content">
              <div>
                CAD模型轻量化解决方案，应用在研发设计阶段，支持多款CAD模型数据轻量化，不破坏原始模型信息，可在多种终端设备方式查看CAD模型数据。
              </div>
              <!-- <div class="buttons">
                <el-button type="primary" @click="UplodClick"
                  >立即体验</el-button
                >
              </div> -->
            </div>
          </div>
          <div class="Solution_solve_right">
            <div>
              <img
                src="../../assets/img/solution/saas.jpg"
                class="Solution_img"
              />
            </div>
          </div>
        </div>
        <div class="solution_pain">
          <div class="solution_pain_box">
            <div class="pain_title">行业痛点</div>
            <div class="pain_content">
              <div
                class="pain_box"
                v-for="(item, index) of painArray"
                :key="index"
              >
                <div class="title">{{ item.title }}</div>
                <div class="container">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="solution_highlights">
          <div class="highlights">
            <div class="highlights_title">方案亮点</div>
            <div class="highlights_box">
              <div
                class="highlights_content"
                v-for="(item, index) in highlightArray"
                :key="index"
              >
                <div class="contents">
                  <div class="saas-circle"></div>
                  <div class="saas-box">
                    <div class="text">
                      {{ item.title }}
                    </div>
                    <div class="content">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EngineModel from "../../components/tabbar/Engine.vue";
import axios from "axios";
import VanillaTilt from "vanilla-tilt";
// let docx = require("docx-preview");
export default {
  name: "solution",
  // components: {
  //   EngineModel
  // },
  data() {
    return {
      tab: 1,
      tableData: [],
      painList: [
        {
          title: "费用高",
          content:
            "CAD数据模型需要对应软件打开，存在多种格式的模型需要配套多款CAD设计软件。"
        },
        {
          title: "查看难",
          content:
            "CAD原始数据无法在网页端、移动端直接查看，一般体量大、面数高的加载慢，操作迟钝。"
        },
        {
          title: "费时费力",
          content:
            "为了使用CAD设计模型，往往还需要手工重建，或者删减店面数，容易破坏模型原始结构信息。"
        }
      ],
      painArray: [
        {
          title: "分享难",
          content: "三维软件打开模型后，截图、共享屏幕分享模型。"
        },
        {
          title: "费用高、浪费资源",
          content:
            "CAD原始数据无法在网页端、移动端直接查看，一般体量大、面数高的加载慢，操作迟钝。"
        },
        {
          title: "繁琐、不方便",
          content:
            "不能三维直接交互，或者通过网络传输图纸分享，造成图纸繁多，传输慢等问题"
        }
      ],
      highlightList: [
        {
          content: [
            "CAD数据模型轻量化转换，输出自主格式PIV，2种不同输出方式",
            "同步模式：CAD设计软件集成可视化输出插件，同步执行、实时输出将CAD数据模型输出；",
            "异步模式：后台工作、批量转换，设计师将模型放到指定路径，无需人工处理便可批量转档；",
            "轻量化输出不改变原始模型，保留结构信息、模型几何、PMI信息、模型属性等支持大装配模型转换压缩可达100：1，高效输出模型完整性；"
          ]
        },
        {
          content: [
            "支持多款CAD设计软件数据格式输出",
            "国际：Creo、CATIA、NX、SolidWorks、Inventor、SolidEdge；",
            "国产：中望3D、新迪天工CAD等；"
          ]
        },
        {
          content: [
            "可视化查看，加载输出PIV可视化文件",
            "设计师快速查看CAD轻量化模型数据，加载大装配模型，查看CAD模型属性、PMI信息，与模型交互剖切、标注、干涉检查等；"
          ]
        }
      ],
      highlightArray: [
        {
          title: "模型数据安全性",
          content:
            "个人安全账号，注册属于自己私人账号，访问个人转档模型，通过二维码或者URL分享，不提供模型下载；"
        },
        {
          title: "支持多种模型数据格式轻量化后分享查看",
          content: "国际：Creo、CATIA、NX、SolidWorks、Inventor、SolidEdge；"
        },
        {
          title: "节省成本，不浪费资源",
          content:
            "模型轻量化自动化处理模型替代人工处理，不需要再用3Dmax、Maya软件模型重构，替换纸质、FTP分享，节省印刷成本；"
        },
        {
          title: "多用户查看，方便快捷",
          content:
            "通过二维码分享，多用户扫码查看，可跨终端设备查看，不受限制，移动端都可以查看模型。用户通过扫码查看模型，加载速度快，与模型进行交互；"
        },
        {
          title: "模型分享查看数据完整性",
          content:
            "模型轻量化仍保留三维模型基本信息，几何外观、PMI信息、模型结构、属性等，扫码查看模型完整的信息。"
        }
      ],
      planList: [
        {
          url: require("../../assets/img/solution/assembly.png"),
          examples: "/二级减速器/asm-jiansuqi.asm",
          text: "装配体查看，查看模型信息，扫码可查看。"
        },
        {
          url: require("../../assets/img/solution/pmi.png"),
          examples: "/PRC_PISX_AXIS_001/PRC_PISX_AXIS_001_10.PRT",
          text: "原始数据PMI信息输出，扫码可查看。"
        },
        {
          url: require("../../assets/img/solution/cooling.png"),
          examples: "/冷机组/zpt.asm",
          text: "冷却机组，原始模型115MB，轻量化后20M，扫码可查看。"
        }
      ],
      loading: false,
      filename: "",
      isinfo: false,
      isActive: false,
      tab1: true,
      ruleForm: {
        name: "",
        email: "",
        tel: "",
        cname: "",
        address: "",
        do: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur"
          },
          {
            validator: function(rule, value, callback) {
              if (
                /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(
                  value
                ) == false
              ) {
                callback(new Error("邮箱格式错误"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        tel: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            validator: function(rule, value, callback) {
              if (
                /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(
                  value
                ) == false
              ) {
                callback(new Error("请输入合法的手机号"));
              } else {
                callback();
              }
            }
          }
        ],
        cname: [
          {
            message: "请输入公司名称",
            trigger: "blur"
          }
        ],
        address: [
          {
            message: "请输入公司地址",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created: function() {
    // console.log("使用插件的renderAsync方法来渲染", docx); //
    this.$emit("FootItem", true);
  },
  mounted() {
    let myTab = this.$route.query.view;
    if (myTab == "solution_desgin") {
      this.tab = 1;
    }
    if (myTab == "solution_saas") {
      this.tab = 2;
    }
    VanillaTilt.init(this.$refs.planCard, {
      max: 20,
      speed: 1000
    });
  },
  methods: {
    tabChange: function(e) {
      let tabid = e.target.dataset.id;
      this.tab = tabid;
      if (tabid === 1 || tabid === 2 || tabid === 3 || tabid === 4) {
        this.tab = tabid;
      } else {
        this.sort = tabid;
      }
      if (tabid == 1) {
        this.close();
      }
      if (tabid == 2) {
        this.goFile();
        this.close();
      }
    },
    intoinfo(row) {
      this.filename = row.filename;
      this.isinfo = true;
      this.isActive = true;
      this.goFile();
    },
    goFile() {
      this.loading = true;
      this.$axios
        .get("http://internal.pisx.com:8012/api/filename")
        .then((res) => {
          // console.log("dddd" + res.data)
          this.tableData = res.data;
          this.loading = false;
          console.log(this.tableData);
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    close() {
      this.isinfo = false;
      this.isActive = false;
      this.ruleForm = {
        name: "",
        email: "",
        tel: "",
        cname: "",
        address: "",
        do: ""
      };
    },
    viewExamples(value) {
      let qrTexxt =
        "http://internal.pisx.com:8013/TundraViewer/dist/professional/index.html#../../Models" +
        value +
        ".piv";
      this.qrTexxt = qrTexxt;
      window.open(this.qrTexxt, "_blank");
    },
    DesignClik() {
      this.$router
        .push({
          path: "/design"
        })
        .catch(() => {});
    },
    UplodClick() {
      // this.$router.replace('/upload');
      this.$router
        .push({
          path: "/upload"
        })
        .catch((err) => err);
    },
    downLoad() {
      this.$axios
        .get("http://internal.pisx.com:8012/api/filedownload", {
          params: {
            filename: this.filename
          },
          responseType: "blob"
        })
        .then(({ data }) => {
          const blob = new Blob([data]);
          var a = document.createElement("a"); //创建一个<a></a>标签
          a.href = URL.createObjectURL(blob); // 将流文件写入a标签的href属性值
          a.download = this.filename; //设置文件名
          a.style.display = "none"; // 障眼法藏起来a标签
          document.body.appendChild(a); // 将a标签追加到文档对象中
          a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
          a.remove(); // 一次性的，用完就删除a标签
        });
      // axios({
      // 	method: "get",
      // 	responseType: "blob", // 因为是流文件，所以要指定blob类型
      // 	url: "http://localhost:8088/api/filedownload", // 自己的服务器，提供的一个word下载文件接口
      // }).then(({
      // 	data
      // }) => {
      // 	// 后端返回的是流文件
      // 	const blob = new Blob([data]); // 把得到的结果用流对象转一下
      // 	var a = document.createElement("a"); //创建一个<a></a>标签
      // 	a.href = URL.createObjectURL(blob); // 将流文件写入a标签的href属性值
      // 	a.download = "Tundra Client_V1.2.docx"; //设置文件名
      // 	a.style.display = "none"; // 障眼法藏起来a标签
      // 	document.body.appendChild(a); // 将a标签追加到文档对象中
      // 	a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      // 	a.remove(); // 一次性的，用完就删除a标签
      // });
    }
  }
};
</script>

<style scoped lang="less">
.solution {
  .solution_info {
    position: relative;
    font-size: 0;
  }
  .solution_top_btn {
    display: flex;
    width: 100%;
    height: 64px;
    background-color: #f0f7fa;
    .solution_btn_box {
      width: 80%;
      margin: 0 auto;
    }
  }
  .solution_pain {
    width: 100%;
    background-color: #f0f7fa;
    .solution_pain_box {
      width: 80%;
      margin: 0 auto;
      .pain_title {
        display: flex;
        justify-content: flex-start;
        font-size: 42px;
        color: #004f92;
        font-weight: bold;
        padding-top: 60px;
      }
      .pain_content {
        padding: 80px 0;
        display: flex;
        justify-content: space-around;
        .pain_box {
          width: 500px;
          border: 1px solid #9d9d9d;
          padding: 10px;
          cursor: pointer;
          .title {
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 10px;
            color: #505050;
          }
          .container {
            font-size: 32px;
            color: #505050;
          }
        }
        .pain_box:hover {
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
        }
        .pain_box:nth-child(2) {
          margin: 0 20px;
        }
      }
    }
  }
  .solution_highlights {
    width: 100%;
    .highlights {
      width: 80%;
      margin: 0 auto;
      padding-bottom: 80px;
      .highlights_title {
        display: flex;
        justify-content: flex-start;
        font-size: 42px;
        color: #004f92;
        font-weight: bold;
        padding-top: 60px;
      }
      .highlights_box {
        margin-top: 30px;
        border: 1px solid #9d9d9d;
        padding: 20px;
      }
      .highlights_content {
        .contents {
          display: flex;
          .left-circle {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #0050ff;
            margin-right: 20px;
            margin-top: 8px;
          }
          .saas-circle {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #0050ff;
            margin-right: 20px;
            margin-top: 6px;
          }
          .right-box {
            margin-bottom: 10px;
            .right {
              display: flex;
              flex-direction: column;
              font-size: 25px;
              color: #505050;
              width: 1100px;
            }
          }
          .saas-box {
            margin-bottom: 10px;
            display: flex;
            flex-direction: column;
            width: 1200px;
            color: #505050;
            font-size: 25px;
            .text {
              font-weight: bold;
            }
            .content {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }

  .solution_plan {
    width: 100%;
    background-color: #f0f7fa;
    .plan {
      width: 80%;
      margin: 0 auto;
      .plan_title {
        display: flex;
        justify-content: flex-start;
        font-size: 42px;
        color: #004f92;
        font-weight: bold;
        padding-top: 60px;
      }
      .plan_box {
        .container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .plan-card {
            display: flex;
            flex-direction: column;
            max-width: 464px;
            margin: 20px;
            background-color: #fff;
            transform-style: preserve-3d;
            transform: perspective(1000px);
            transition: box-shadow 0.3s ease-in-out;
            .card-image {
              cursor: pointer;
              transform: translateZ(20px);
            }
            .card-content {
              display: flex;
              flex-direction: column;
              padding: 20px;
              .card-text {
                font-size: 24px;
                margin: 10px 0;
                height: 70px;
              }
              .card-button {
                align-self: center;
                background-color: #f5f5f5;
                padding: 10px 24px;
                border-radius: 4px;
                font-size: 16px;
                cursor: pointer;
                color: #000;
                border: 1px solid #000;
              }
              .card-button:hover {
                background-color: #0047ff;
                color: #fff;
                border: none;
              }
            }
          }
          .plan-card:hover {
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
          }
        }
      }
    }
  }
}
.solve_left__text {
  color: rgba(80, 80, 80, 1);
  font-size: 20px;
}

.solve_left__content {
  margin-top: 120px;
  color: rgba(80, 80, 80, 1);
  font-size: 24px;
  width: 550px;
}

.saas_left__content {
  margin-top: 80px;
  color: rgba(80, 80, 80, 1);
  font-size: 24px;
  width: 550px;
  .buttons {
    margin-top: 50px;
  }
}
.solve_right__content {
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
  margin-top: 80px;
}
.solve_line {
  position: relative;
}

.solve_line::after {
  content: "";
  display: block;
  width: 550px;
  height: 2px;
  background-color: rgba(80, 80, 80, 1);
  position: absolute;
  bottom: -8px;
  left: 0;
}

.down-img {
  width: 20px;
  height: 20px;
}

.file-name {
  margin-left: 10px;
}
</style>
